__turbopack_context__.v({
  "address": "YatmoMap-module-scss-module__vlYaEW__address",
  "frame": "YatmoMap-module-scss-module__vlYaEW__frame",
  "loading": "YatmoMap-module-scss-module__vlYaEW__loading",
});
